import vars from '../../helpers';

export default function () {
	return new Promise((resolve) => {
		const gsapElements = ['.header__title', '.header__text p', '.header__arrow', '.header__five-reasons', '.section-video__title span', '.section-video__text'];

		const tl = gsap.timeline({
			paused: true,
			onStart() {
				gsapElements.forEach((item) => {
					$(item).removeClass('is-hidden');
				});
			},
			onComplete() {
				gsap.killTweensOf(gsapElements);
				gsap.set(gsapElements, {clearProps: 'all'});

				resolve();
			},
		});

		setTimeout(() => {
			tl.play();
		}, 350);

		const duration = 1;
		const delay = `-=${duration / 2}`;
		const commonProps = {
			duration,
			ease: 'sine.out',
			transition: 'none',
		};

		function tlArrow() {
			tl.from('.header__arrow', {
				...commonProps,
				opacity: 0,
				yPercent: -100,
				onComplete() {
					vars.isScreen.isMobile(() => {
						this.targets()[1].classList.add('is-animated');
						this.targets()[0].classList.remove('is-animated');
					});

					vars.isScreen.isDesktop(() => {
						this.targets()[0].classList.add('is-animated');
						this.targets()[1].classList.remove('is-animated');
					});
				},
			}, delay);
		}

		// Title
		tl.from('.header__title', {
			...commonProps,
			opacity: 0,
			yPercent: -100,
			stagger: duration / 2,
		}, delay);

		tl.from('.header__text p', {
			...commonProps,
			opacity: 0,
			yPercent: -100,
		}, delay);

		vars.isScreen.isDesktop(tlArrow);

		tl.from('.header__five-reasons', {
			...commonProps,
			opacity: 0,
			yPercent: -100,
		}, delay);

		vars.isScreen.isMobile(tlArrow);
	});
}
